"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeadingMobile = exports.HeadingDesktop = exports.GuideCardStatic = exports.GuideCardLink = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _vars = require("../../styles/vars");
var _Link = _interopRequireDefault(require("../Link"));
var _Heading = require("../Heading");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
//helpers

//components

var GuideCardStatic = exports.GuideCardStatic = _styledComponents["default"].div.withConfig({
  displayName: "styles__GuideCardStatic",
  componentId: "sc-i0id9d-0"
})(["", ";background:#fff;border-radius:", "px;overflow:hidden;display:block;height:100%;"], function (p) {
  return (0, _vars.cardShadowCss)(p.device === 'desktop' && p.isLink);
}, function (p) {
  return _vars.borderRadius[p.device];
});
var GuideCardLink = exports.GuideCardLink = GuideCardStatic.withComponent(_Link["default"]);
var HeadingDesktop = exports.HeadingDesktop = (0, _styledComponents["default"])(_Heading.HeadingDesktop).attrs({
  maxLines: 3,
  size: 'xsmall'
}).withConfig({
  displayName: "styles__HeadingDesktop",
  componentId: "sc-i0id9d-1"
})(["&&{margin:0.8rem 1rem;}"]);
var HeadingMobile = exports.HeadingMobile = HeadingDesktop.withComponent(_Heading.HeadingMobile);
//# sourceMappingURL=styles.js.map